import React from 'react';
import NotificationExample from '../components/common/NotificationExample';

const Settings = () => {
  return (
    <div className='container mx-auto py-6'>
      <h1 className='text-2xl font-bold mb-6'>Cài đặt</h1>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <div className='col-span-1'>
          <div className='p-6 bg-white rounded-lg shadow-md'>
            <h2 className='text-lg font-medium mb-4'>Cài đặt chung</h2>
            <p className='text-gray-600'>Tính năng đang được phát triển...</p>
          </div>
        </div>

        <div className='col-span-1'>
          <NotificationExample />
        </div>
      </div>
    </div>
  );
};

export default Settings;
